import axios from 'axios';
import {router} from "@inertiajs/react";
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                console.log("Received 401 (unauthorized) response, reloading page to trigger login.");
                router.reload()
            }

            if (status === 419) {
                console.log("Received 419 (session expired) response, reloading page to trigger login.");
                router.reload()
            }
        }

        return Promise.reject(error);
    }
);
